<template>
  <div>
    <main id="PAGES_CONTAINER" tabindex="-1" class=" privacy-policy-container size-card shadow-container-policy">
      <div id="SITE_PAGES" class="_1gF1C">
        <div id="a6qx8" class="Ry26q">
          <div class="_3CemL" data-testid="page-bg"></div>
          <div class="_3K7uv">
            <div id="Containera6qx8" class="_1KV2M">
              <div data-mesh-id="Containera6qx8inlineContent" data-testid="inline-content" class="">
                <div data-mesh-id="Containera6qx8inlineContent-gridContainer" data-testid="mesh-container-content">
                  <div id="comp-l56rkrdz" class="_2Hij5 _3bcaz" data-testid="richTextElement">
                    <p class="font_8" style="font-size:38px; text-align:justify;">
                      <span style="font-weight:bold;">
                        <span style="font-size:38px;">
                          <span style="color:#216D40;">Política de Privacidade Health ID</span><br></br>
                          <span style="color:#216D40;">TERMO DE CONSENTIMENTO LIVRE E ESCLARECIDO (TCLE) -
                            PACIENTE</span>
                        </span>
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;">&nbsp;</p>

                    <p class="font_8" style="text-align:justify; font-size:16px;">
                      <b><span style="color:#216D40;">Prova de Conceito – Monitoramento de Lítio por Coleta de Sangue
                          Capilar</span></b>
                    </p>


                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Você está sendo convidado(a) a participar da Prova de Conceito para detecção dos níveis de lítio
                        no organismo, por meio da coleta de sangue capilar. O procedimento será realizado no consultório
                        do profissional médico responsável pelo seu acompanhamento. Esta iniciativa tem como
                        finalidade desenvolver e avaliar o desempenho de dispositivos da Health ID Lab voltados à coleta
                        de microamostras de sangue, com foco em monitoramento terapêutico de pacientes em uso de
                        carbonato de lítio (TDM – Therapeutic Drug Monitoring).</span>
                    </p>


                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        A coleta capilar é uma alternativa menos invasiva, mais prática e confortável em relação à
                        tradicional coleta venosa. Permite a obtenção de amostras com apenas algumas gotas de sangue,
                        sem a necessidade de punção venosa, sendo especialmente útil em contextos domiciliares, em
                        regiões remotas ou para pacientes que requerem monitoramento frequente.
                      </span>
                    </p>


                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        A presente prova de conceito é voltada para pacientes em uso de carbonato de lítio. O objetivo é
                        identificar possíveis níveis de subdosagem ou toxicidade, de forma a possibilitar que o médico
                        assistente realize os ajustes necessários na dosagem do medicamento.
                      </span>
                    </p>


                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Sua participação é voluntária e consistirá na coleta de uma amostra de sangue capilar, por meio
                        de um dos dispositivos desenvolvidos pela Health ID Lab. O processo utiliza uma lanceta, gaze,
                        lenço umedecido com álcool gel e curativo adesivo. A coleta será realizada ou orientada pelo
                        médico responsável, conforme o manual técnico disponibilizado pela Health ID. Além da coleta,
                        será aplicado um questionário breve, totalizando aproximadamente 15 minutos de participação.
                      </span>
                    </p>


                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Os riscos relacionados ao procedimento são mínimos, limitando-se à dor no local da perfuração
                        com a lanceta. Caso ocorra qualquer desconforto ou intercorrência, serão ofertados cuidados
                        médicos imediatos, sem custo para o participante.
                      </span>
                    </p>


                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Ao participar, você autoriza o compartilhamento de suas amostras e dados com o laboratório
                        responsável pelo processamento, bem como com o seu médico assistente, para fins clínicos. Além
                        disso, declara estar ciente de que os dados anonimizados ou consolidados poderão ser utilizados
                        para fins de pesquisa, garantindo-se o sigilo e a privacidade das informações, conforme a
                        legislação vigente.
                      </span>
                    </p>


                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Você tem liberdade para recusar ou interromper sua participação a qualquer momento, sem
                        necessidade de justificativa e sem qualquer prejuízo ao seu tratamento médico
                      </span>
                    </p>


                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                      LI E ACEITO os Termos de Consentimento Livre e Esclarecido (TCLE) e o inteiro teor da Política de Privacidade apresentada
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;">
                      <b><span style="color:#216D40;">TERMO DE CONSENTIMENTO LIVRE E ESCLARECIDO (TCLE) -
                          MÉDICO</span></b>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;">
                      <b><span style="color:#216D40;">Prova de Conceito – Monitoramento de Lítio por Coleta de Sangue
                          Capilar</span></b>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;">
                      <b><span style="color:#216D40;">Participação do Médico Colaborador</span></b>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Você está sendo convidado(a) a participar, como médico colaborador, da Prova de Conceito para
                        detecção dos níveis de lítio no organismo, por meio da coleta de sangue capilar com uso de
                        dispositivos desenvolvidos pela empresa Health ID. A prova será conduzida no seu consultório
                        médico, mediante sua supervisão direta.
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        O objetivo desta prova de conceito é avaliar a aplicabilidade clínica de dispositivos para
                        coleta de
                        microamostras de sangue, com foco no monitoramento terapêutico de pacientes em tratamento
                        com carbonato de lítio (TDM – Therapeutic Drug Monitoring). A proposta é identificar possíveis
                        níveis de subdosagem ou toxicidade e, com isso, subsidiar decisões clínicas quanto ao ajuste da
                        dosagem medicamentosa.
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Como médico colaborador, sua participação consistirá em:
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Orientar ou realizar a coleta de sangue capilar em seus pacientes, utilizando os dispositivos da
                        Health ID, conforme o manual técnico fornecido (em anexo);
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Acondicionar as amostras coletadas na caixa apropriada disponibilizada pela Health ID,
                        observando as instruções de armazenamento e conservação;
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Entregar periodicamente essas amostras ao laboratório parceiro, por meio de retirada agendada
                        diretamente no endereço de seu consultório;
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Oferecer assistência clínica imediata, caso o paciente apresente qualquer dor ou desconforto
                        decorrente da punção com lanceta;
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Fornecer esclarecimentos e apoio aos pacientes, caso surjam dúvidas ou intercorrências durante
                        o processo de coleta.
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        A coleta será realizada com o uso de lanceta estéril, gaze, lenço com álcool gel e curativo
                        adesivo,
                        itens fornecidos junto com o kit do dispositivo. O procedimento leva, em média, 15 minutos,
                        incluindo o preenchimento de um breve questionário
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Todas as informações clínicas dos pacientes permanecerão sob sua guarda e responsabilidade,
                        sendo garantido o sigilo e o tratamento adequado dos dados conforme a legislação vigente,
                        incluindo a Lei Geral de Proteção de Dados (LGPD). Os dados anonimizados e consolidados
                        poderão ser utilizados pela Health ID e seus parceiros exclusivamente para fins de pesquisa
                        científica e validação tecnológica, sem qualquer identificação individual dos pacientes.
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Sua adesão a esta iniciativa é voluntária, não implicando vínculo empregatício ou qualquer
                        obrigação futura com a Health ID. Você poderá interromper sua participação a qualquer momento,
                        sem prejuízo à relação com a empresa ou com os pacientes.
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                      LI E ACEITO os Termos de Consentimento Livre e Esclarecido (TCLE) e o inteiro teor da Política de Privacidade apresentada
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;">
                      <b><span style="color:#216D40;">Política de Privacidade Health ID</span></b>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;">
                      <b><span style="color:#216D40;">Introdução</span></b>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Esta Política de Privacidade regulamenta o tratamento de dados pessoais de clientes,
                        colaboradores, parceiros, usuários finais dos clientes sob a responsabilidade da Health ID Lab,
                        além de visitantes dos serviços online mantidos pela empresa.
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        A presente Política de Privacidade representa o nosso compromisso com a transparência, a
                        integridade e o respeito à privacidade, à proteção e à segurança dos dados pessoais dos usuários
                        e de nossos stakeholders, em particular de nossos colaboradores, parceiros e restantes dos
                        titulares
                        dos dados que estejam sob a nossa guarda.
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Por favor leia atentamente esta política antes de usar ou obter quaisquer materiais,
                        informações,
                        produtos ou serviços da empresa. Nos reservamos o direito de alterar, atualizar ou corrigir esta
                        política a qualquer momento. Ao usar nossos serviços, você consente com a nossa Política de
                        Privacidade e Proteção de Dados e com a coleta, uso e compartilhamento de suas informações
                        conforme descrito abaixo.
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;">
                      <b><span style="color:#216D40;">Entidade Responsável pelo tratamento de Dados</span></b>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        A entidade responsável pelo tratamento dos dados é Health ID Lab Lab Ltda., inscrita no CNPJ
                        sob o número 34.037.799/0001-02, com sede na Alameda da Inovação, 270 – Campo Bom, RS.
                        Você pode contatar o nosso Encarregado de Dados (DPO) Anderson Cardoso pelo telefone (11)
                        95555-4624 ou pelo e-mail seguranca@clichealthid.com
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;">
                      <b><span style="color:#216D40;">Princípios observados</span></b>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Toda informação pessoal identificável que você nos fornece será usada somente de acordo com o
                        permitido por lei, incluindo o necessário para oferecer o produto, serviço ou informação
                        solicitada
                        por você.
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Seus dados pessoais não serão vendidos ou alugados e o compartilhamento, se houver, se limita
                        a nossos parceiros de negócio conforme requerido na execução de nossos serviços ou conforme
                        exigido por leis e regulamentações, caso em que a Health ID Lab adota todas medidas necessárias
                        para assegurar que os subcontratados satisfazem os requisitos legais aplicáveis e oferecem as
                        garantias adequadas para a proteção dos dados.
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Certos clientes e parceiros de negócio da Health ID Lab também poderão compartilhar dados
                        pessoais com nossa empresa para fins necessários ao seu relacionamento direto com aquelas
                        entidades e neste caso reportar-se-á à Política de Privacidade destas entidades específicas.
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        A Health ID Lab também observa as práticas recomendadas de Segurança da Informação e adota
                        medidas técnicas, organizacionais e administrativas para proteger os dados pessoais de acessos
                        não autorizados e de situações acidentais ou ilícitas de destruição, perda, alteração,
                        comunicação
                        ou difusão, bem como para atuar de conformidade com a Lei Geral de Proteção de Dados Pessoais
                        (Lei nº 13.709/18) e demais regulamentos sobre a matéria.
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;">
                      <b><span style="color:#216D40;">Fundamento para o Tratamento de Dados</span></b>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        No exercício das atividades empresariais da Health ID Lab, o tratamento de dados pessoais
                        enquadra-se no consentimento dos titulares, na execução e cumprimento de contrato a pedido do
                        titular, no exercício regular de direito em processo judicial e no legítimo interesse da
                        empresa,
                        sendo assegurados aos titulares os direitos previstos na Lei Geral de Proteção de Dados Pessoais
                        (Lei Nº 13.709/18). Que dados pessoais são recolhidos e tratados?
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        A Health ID Lab poderá recolher e tratar, entre outros, os seguintes dados pessoais:
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        a) Visitantes do Site: Endereço IP, porta de conexão, informações fornecidas pelo navegador,
                        cookies necessários para o correto funcionamento do site ou aplicação e ainda, no caso de
                        visitantes autenticados, informações de usuário e senha de acesso;
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        b) Recrutamento e seleção de colaboradores: nome, endereço de correio eletrônico e currículo
                        vitae;
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        c) Usuários das aplicações web providas pela Health ID Lab: Nome, CPF, e-mail, telefone, senha
                        de acesso, foto de perfil, data de nascimento e outras informações que o titular dos dados optou
                        por nos fornecer;
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        d) Titulares cujo controlador do tratamento de dados pessoais seja entidade, empresa ou
                        organização cliente da Health ID Lab: Nome, CPF, RG, data de nascimento, dados de saúde e
                        outras informações presentes nas aplicações providas pela Health ID Lab a seus clientes.
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        De que forma os seus dados são coletados?
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Os dados pessoais podem ser coletados através dos seguintes meios:
                      </span>
                    </p>
                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        a) Website e formulários online;
                      </span>
                    </p>
                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        b) Chamadas telefônicas;
                      </span>
                    </p>
                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        c) Correio eletrônico;
                      </span>
                    </p>
                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        d) Através de aplicações (“apps”) instaladas em dispositivos móveis;
                      </span>
                    </p>
                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        e) Quando fornecidos pelos clientes da Health ID Lab.
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Alguns dados pessoais recolhidos são de preenchimento obrigatório e necessários para a execução
                        e realização de nossas atividades, sendo que, em caso de falta ou insuficiência desses dados, a
                        Health ID Lab se resguarda no direito de não prestar os serviços ou as informações solicitadas.
                        Em cada caso concreto, a Health ID Lab irá informá-lo sobre a natureza obrigatória do
                        fornecimento destes dados pessoais e a finalidade de sua utilização.
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Por quanto tempo os dados pessoais são armazenados?
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        A Health ID Lab cumpre com as normas legais relativas aos prazos de retenção de dados pessoais,
                        podendo mantê-los conforme requerido por lei ou enquanto for necessário para execução de
                        contrato ou serviço.
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;">
                      <b><span style="color:#216D40;">Direitos dos titulares de dados pessoais</span></b>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        A Health ID Lab assegura aos titulares o exercício dos direitos de confirmação de tratamento,
                        acesso aos dados, correção de dados, eliminação, revogação do consentimento e demais direitos
                        previstos em lei. Para exercer os seus direitos, entre em contato com a Health ID Lab através do
                        email: seguranca@clichealthid.com, encaminhando-nos, conforme for o caso, pedido para
                        adaptação, alteração ou exclusão de seus dados.
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;">
                      <b><span style="color:#216D40;">Utilização de Cookies</span></b>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Cookies são pequenos dados enviados por um servidor web para o seu navegador e armazenado
                        no seu computador ou dispositivo pessoal. Para oferecer melhor experiência no uso de nossos
                        serviços web e aplicações, poderemos usar cookies de sessão (que expiram quando você fecha o
                        navegador) e cookies persistentes (que permanecem no seu computador até que você os delete).
                        Este tipo de informação é coletada para tornar o serviço mais útil e oferecer uma experiência
                        mais
                        conveniente e valiosa para você.
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Usamos duas categorias de cookies: Cookies servidos diretamente por nós ao seu computador ou
                        dispositivo para que possamos reconhecê-lo quando você retorna ao nosso site e cookies de
                        terceiros, usados para estatísticas de acesso, segurança e disponibilidade do site.
                      </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;">
                      <b><span style="color:#216D40;">Alterações na Política</span></b>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                        Se fizermos alterações nessa Política de Privacidade, iremos informá-lo da mudança na próxima
                        visita ao site e você também poderá entrar em contato com a Health ID Lab via o e-mail
                        seguranca@clichealthid.com para direcionar seus questionamentos em relação à mesma.
                      </span>
                    </p>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <div class=" size-card">
      <div class="input-box">
        <div class="checkbox-text">
          <input id="accept_terms" type="checkbox" v-model="accept_terms" value="1" />
          <p for="accept_terms" style="line-height: 2">
            Declaro estar ciente e aceito os termos da política de privacidade apresentados.
          </p>
        </div>
        <div class="form-error" v-if="errors && errors.accept_terms.length > 0">
          <small class="error">
            {{ errors.accept_terms.join() }}
          </small>
        </div>
      </div>
      <button class="button btn-primary" @click="handleSubmit">Salvar e Próximo</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  props: {
    next: Function
  },
  data() {
    return {
      errors: {
        accept_terms: []
      },
      accept_terms: false,
    }
  },
  methods: {
    handleSubmit() {
      if (!this.accept_terms) {
        this.errors.accept_terms.push("Que Pena! Mas precisamos dessa concordância para realizar a análise da sua amostra. Quer concordar com o termo de consentimento?");
        return false;
      } else {
        console.log();
        this.$emit('next', this.accept_terms)
      }
    }
  }
}
</script>

<style scoped>
@import "./../FormSteps/form-steps.scss";
@import "./../FormSteps/responsive.css";

.privacy-policy-container {
  max-height: 50vh;
  overflow: auto;
}

.size-card {
  max-width: 100%;
  margin: 0 auto;

}

.shadow-container-policy {
  box-shadow: inset -7px -4px 1px 1px #216d400d;
  border: 1px solid #c3c3c345;
  padding: 16px;
}

.input-box {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/RegisterKitSteps/PrivacyPolicy.vue